<!-- Main Calendar View -->
<div class="programari-calendar">
    <!-- Header -->
    <div class="calendar-header">
        <div class="header-left">
            <div class="header-title">
                <h2>Programări Activități</h2>
                <p class="subtitle">{{ getMonthYearLabel() }}</p>
            </div>
        </div>

        <div class="header-center">
            <div class="view-switcher">
                <mat-button-toggle-group [value]="currentView" (change)="switchView($event.value)"
                    class="view-toggle-group">
                    <mat-button-toggle *ngFor="let option of viewOptions" [value]="option.value">
                        <mat-icon>{{ option.icon }}</mat-icon>
                        <span class="view-label">{{ option.label }}</span>
                    </mat-button-toggle>
                </mat-button-toggle-group>
            </div>
        </div>

        <div class="header-right">
            <div class="header-actions">
                <div class="navigation-controls">
                    <button mat-icon-button (click)="previousPeriod()">
                        <mat-icon>chevron_left</mat-icon>
                    </button>

                    <button mat-stroked-button (click)="goToToday()" class="today-btn">
                        Astazi
                    </button>

                    <button mat-icon-button (click)="nextPeriod()">
                        <mat-icon>chevron_right</mat-icon>
                    </button>
                </div>

                <button mat-raised-button color="primary" (click)="createNewActivity()" *ngIf="canCreateActivity()">
                    <mat-icon>add</mat-icon>
                    Activitate nouă
                </button>

                <!-- Export Menu -->
                <div class="export-controls">
                    <button mat-button [matMenuTriggerFor]="exportMenu" [disabled]="filteredActivities.length === 0">
                        <mat-icon>download</mat-icon>
                        Export
                    </button>
                    <mat-menu #exportMenu="matMenu">
                        <button mat-menu-item (click)="exportActivities('pdf')">
                            <mat-icon>picture_as_pdf</mat-icon>
                            <span>Export PDF</span>
                        </button>
                        <button mat-menu-item (click)="exportActivities('csv')">
                            <mat-icon>table_chart</mat-icon>
                            <span>Export CSV</span>
                        </button>
                        <mat-divider></mat-divider>
                        <button mat-menu-item (click)="exportCurrentDay('pdf')"
                            [disabled]="currentView !== 'day' || getDayActivities().length === 0">
                            <mat-icon>today</mat-icon>
                            <span>Zi curentă (PDF)</span>
                        </button>
                        <button mat-menu-item (click)="exportCurrentWeek('pdf')"
                            [disabled]="currentView !== 'week' || weekActivities.length === 0">
                            <mat-icon>view_week</mat-icon>
                            <span>Săptămână curentă (PDF)</span>
                        </button>
                    </mat-menu>
                </div>

                <button mat-icon-button (click)="showFilters = !showFilters" [class.active]="showFilters">
                    <mat-icon>filter_list</mat-icon>
                </button>
            </div>
        </div>
    </div>

    <!-- Filters Panel -->
    <div class="filters-panel" *ngIf="showFilters">
        <form [formGroup]="filtersForm">
            <div class="filter-content">
                <!-- Status Filters -->
                <div class="filter-section">
                    <label>Status:</label>
                    <mat-checkbox *ngFor="let status of statusOptions"
                        [checked]="selectedStatusFilters.includes(status.key)" (change)="toggleStatusFilter(status.key)"
                        class="status-checkbox">
                        <span class="status-indicator" [style.background-color]="status.color"></span>
                        {{ status.label }}
                    </mat-checkbox>
                </div>

                <!-- Organizational Filters -->
                <div class="filter-section">
                    <div class="filter-row">
                        <mat-form-field appearance="outline">
                            <!-- <mat-label>Direcție</mat-label>
                            <mat-select [(ngModel)]="selectedDirectieId" (selectionChange)="onDirectieChange($event.value)">
                                <mat-option [value]="null">-- Toate Direcțiile --</mat-option>
                                <mat-option *ngFor="let directie of directii" [value]="directie.id_directie">
                                    {{ directie.name }}
                                </mat-option>
                            </mat-select> -->
                            <mat-label>Direcție</mat-label>
                            <mat-select formControlName="directie_id" (openedChange)="onDirectieSelectClosed()"
                                (selectionChange)="onDirectieChange($event.value)">
                                <mat-form-field class="px-2 w-100 sticky-input">
                                    <input matInput [formControl]="directiiControl" (keydown)="$event.stopPropagation()"
                                        (click)="$event.stopPropagation()" />
                                </mat-form-field>

                                <mat-option *ngIf="filteredDirectii.length === 0" disabled>
                                    <span>No results found</span>
                                </mat-option>

                                <mat-option [value]="-1">-- Alegeți --</mat-option>
                                <mat-option *ngFor="let directie of filteredDirectii" [value]="directie.id">
                                    {{ directie.name }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>

                        <mat-form-field appearance="outline">
                            <mat-label>Compartiment</mat-label>
                            <mat-select formControlName="compartiment_id" (openedChange)="onCompartimentSelectClosed()"
                                (selectionChange)="onCompartimentChange($event.value)">
                                <mat-form-field class="px-2 w-100 sticky-input">
                                    <input matInput [formControl]="compartimenteControl"
                                        (keydown)="$event.stopPropagation()" (click)="$event.stopPropagation()" />
                                </mat-form-field>

                                <mat-option *ngIf="filteredCompartimente.length === 0" disabled>
                                    <span>No results found</span>
                                </mat-option>

                                <mat-option [value]="-1">-- Alegeți --</mat-option>

                                <mat-option *ngFor="let compartiment of filteredCompartimente"
                                    [value]="compartiment.id">
                                    {{ compartiment.name }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <div class="filter-row">
                        <mat-form-field appearance="outline">
                            <mat-label>Operator/Utilizator</mat-label>
                            <mat-select formControlName="user_id" (openedChange)="onUsersSelectClosed()"
                                (selectionChange)="onUserChange()">
                                <mat-form-field class="px-2 w-100 sticky-input">
                                    <input matInput [formControl]="usersControl" (keydown)="$event.stopPropagation()"
                                        (click)="$event.stopPropagation()" />
                                </mat-form-field>

                                <mat-option *ngIf="filteredUsers.length === 0" disabled>
                                    <span>No results found</span>
                                </mat-option>

                                <mat-option [value]="-1">-- Alegeți --</mat-option>
                                <mat-option *ngFor="let user of filteredUsers" [value]="user.id">
                                    {{ user.name }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>

                        <div class="filter-actions">
                            <button mat-button (click)="clearOrganizationalFilters()">
                                <mat-icon>clear</mat-icon>
                                Resetează
                            </button>
                            <button mat-stroked-button color="primary" (click)="viewUserCalendar()"
                                [disabled]="filtersForm.get('user_id')?.value === -1">
                                <mat-icon>calendar_view_month</mat-icon>
                                Vezi Calendar
                            </button>
                        </div>
                    </div>
                </div>

                <!-- Search -->
                <div class="filter-section">
                    <mat-form-field appearance="outline">
                        <mat-label>Caută activitate</mat-label>
                        <input matInput formControlName="search_text">
                        <mat-icon matSuffix>search</mat-icon>
                    </mat-form-field>
                </div>

                <!-- Date Range Filter -->
                <div class="filter-section">
                    <div class="filter-row">
                        <mat-form-field appearance="outline">
                            <mat-label>Data început</mat-label>
                            <input matInput [matDatepicker]="startPicker" formControlName="start_date"
                                (dateChange)="onDateFilterChange()" readonly (focus)="startPicker.open()">
                            <mat-datepicker-toggle matIconSuffix [for]="startPicker"></mat-datepicker-toggle>
                            <mat-datepicker #startPicker></mat-datepicker>
                        </mat-form-field>

                        <mat-form-field appearance="outline">
                            <mat-label>Data sfârșit</mat-label>
                            <input matInput [matDatepicker]="endPicker" formControlName="end_date"
                                (dateChange)="onDateFilterChange()" readonly (focus)="endPicker.open()">
                            <mat-datepicker-toggle matIconSuffix [for]="endPicker"></mat-datepicker-toggle>
                            <mat-datepicker #endPicker></mat-datepicker>
                        </mat-form-field>
                    </div>
                </div>
            </div>
        </form>
    </div>

    <!-- Loading State -->
    <div class="loading-container" *ngIf="isLoading">
        <mat-spinner diameter="40"></mat-spinner>
        <p>Se încarcă activitățile...</p>
    </div>

    <!-- Calendar Content -->
    <div class="calendar-content">
        <!-- Month View -->
        <div class="month-view" *ngIf="currentView === 'month'">
            <div class="calendar-container">
                <div class="calendar-grid">
                    <!-- Days of week header -->
                    <div class="calendar-header-row">
                        <div class="calendar-day-header" *ngFor="let day of weekDays">{{ day }}</div>
                    </div>

                    <!-- Calendar weeks -->
                    <div class="calendar-body">
                        <div class="calendar-week" *ngFor="let week of calendarWeeks; trackBy: trackByWeek">
                            <div class="calendar-day" *ngFor="let day of week; trackBy: trackByDay"
                                [class.other-month]="!day.isCurrentMonth" [class.today]="day.isToday"
                                [class.selected]="day.isSelected"
                                [class.has-activities]="day.activities && day.activities.length > 0"
                                (click)="selectDate(day.date)">
                                <div class="day-number">{{ day.day }}</div>
                                <div class="day-activities" *ngIf="day.activities && day.activities.length > 0">
                                    <div class="activity-item"
                                        *ngFor="let activity of day.activities | slice:0:4; let i = index; trackBy: trackByActivity"
                                        [style.border-left-color]="getActivityColor(activity)"
                                        [title]="getActivityTooltip(activity)"
                                        (click)="onActivityClick(activity, $event)">
                                        <div class="activity-time">{{ getActivityTime(activity) }}</div>
                                        <div class="activity-title">{{ getActivityTitleText(activity) }}</div>
                                        <div class="activity-type" *ngIf="getActivityType(activity)">
                                            {{ getActivityType(activity) }}
                                        </div>
                                    </div>
                                    <div class="activity-overflow" *ngIf="day.activities.length > 4">
                                        <small>+{{ day.activities.length - 4 }} mai mult{{day.activities.length - 4 ===
                                            1 ? 'a' : 'e'}}</small>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Week View -->
        <div class="week-view" *ngIf="currentView === 'week'">
            <div class="week-container">
                <!-- Week Header -->
                <div class="week-header">
                    <div class="time-column-header">Ora</div>
                    <div class="day-column-header" *ngFor="let day of weekDays; let i = index">
                        <div class="day-name">{{ day }}</div>
                        <div class="day-date">{{ getWeekDayDate(i) }}</div>
                    </div>
                </div>

                <!-- Week Body -->
                <div class="week-body">
                    <div class="week-row" *ngFor="let hour of weekTimeSlots">
                        <div class="time-label">{{ hour }}</div>
                        <div class="day-time-slot" *ngFor="let day of weekDays; let dayIndex = index"
                            [class.current-time]="isCurrentTimeSlot(dayIndex, hour)"
                            (click)="createActivityAtTime(getWeekDayDate(dayIndex, true), hour)">

                            <!-- Activities in this time slot -->
                            <div class="week-activity" *ngFor="let activity of getActivitiesForTimeSlot(dayIndex, hour)"
                                [style.background-color]="getActivityColor(activity)"
                                [title]="getActivityTooltip(activity)" (click)="onActivityClick(activity, $event)">
                                <div class="activity-title">{{ activity.title }}</div>
                                <div class="activity-time">{{ formatTime(activity.start_time) }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Day View -->
        <div class="day-view" *ngIf="currentView === 'day'">
            <div class="day-container">
                <!-- Day Header -->
                <div class="day-header">
                    <h3>{{ formatDayViewHeader(currentDate) }}</h3>
                    <div class="day-navigation">
                        <button mat-icon-button (click)="previousDay()">
                            <mat-icon>chevron_left</mat-icon>
                        </button>
                        <button mat-stroked-button (click)="goToTodayDay()">
                            Astăzi
                        </button>
                        <button mat-icon-button (click)="nextDay()">
                            <mat-icon>chevron_right</mat-icon>
                        </button>
                    </div>
                </div>

                <!-- Day Schedule -->
                <div class="day-schedule">
                    <div class="day-time-row" *ngFor="let hour of dayTimeSlots">
                        <div class="day-time-label">{{ hour }}</div>
                        <div class="day-time-slot" [class.current-time]="isCurrentDayTimeSlot(hour)"
                            (click)="createActivityAtTime(formatDateForAPI(currentDate), hour)">

                            <!-- Activities in this time slot -->
                            <div class="day-activity" *ngFor="let activity of getDayActivitiesForTimeSlot(hour)"
                                [style.background-color]="getActivityColor(activity)"
                                [title]="getActivityTooltip(activity)" (click)="onActivityClick(activity, $event)">
                                <div class="activity-header">
                                    <span class="activity-title">{{ activity.title }}</span>
                                    <span class="activity-duration">{{ activity.duration_minutes }}min</span>
                                </div>
                                <div class="activity-time">
                                    {{ formatTime(activity.start_time) }} - {{ formatTime(activity.end_time) }}
                                </div>
                                <div class="activity-type" *ngIf="activity.activity_type">
                                    {{ activity.activity_type.name }}
                                </div>
                                <div class="activity-location" *ngIf="activity.location">
                                    <mat-icon>place</mat-icon>
                                    {{ activity.location }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Empty day state -->
                <div class="empty-day" *ngIf="getDayActivities().length === 0">
                    <mat-icon class="empty-icon">event_available</mat-icon>
                    <h4>Nu sunt activități programate pentru {{ formatDayViewHeader(currentDate) }}</h4>
                    <button mat-raised-button color="primary" (click)="createNewActivity()">
                        <mat-icon>add</mat-icon>
                        Adaugă activitate
                    </button>
                </div>
            </div>
        </div>

        <!-- Agenda View -->
        <div class="agenda-view" *ngIf="currentView === 'agenda'">
            <div class="activities-list">
                <div class="activity-card" *ngFor="let activity of filteredActivities; trackBy: trackByActivity">
                    <mat-card class="activity-item" (click)="viewActivityDetails(activity)">
                        <mat-card-header>
                            <mat-card-title>{{ activity.title || 'Activitate nouă' }}</mat-card-title>
                            <mat-card-subtitle>
                                {{ formatActivityDate(activity.scheduled_date) }} •
                                {{ formatTime(activity.start_time) }} - {{ formatTime(activity.end_time) }}
                            </mat-card-subtitle>
                            <div class="status-indicator ms-4"
                                [style.background-color]="getStatusColor(activity.status)">
                            </div>
                        </mat-card-header>
                        <mat-card-content *ngIf="activity.description">
                            <p class="activity-description">{{ activity.description }}</p>
                        </mat-card-content>
                        <mat-card-actions>
                            <button mat-button class="me-2" (click)="editActivity(activity); $event.stopPropagation()">
                                <mat-icon>edit</mat-icon>
                                Editeaza
                            </button>
                            <button mat-stroked-button color="primary"
                                (click)="updateActivityStatus(activity, 'completed'); $event.stopPropagation()">
                                <mat-icon>check</mat-icon>
                                Marchează complet
                            </button>
                        </mat-card-actions>
                    </mat-card>
                </div>
            </div>

            <!-- Empty state for agenda -->
            <div class="empty-agenda" *ngIf="filteredActivities.length === 0">
                <mat-icon class="empty-icon">event_available</mat-icon>
                <h3>Nu sunt activitati programate</h3>
                <p>Adauga o activitate noua pentru a incepe.</p>
                <button mat-raised-button color="primary" (click)="createNewActivity()">
                    <mat-icon>add</mat-icon>
                    Creaza activitate
                </button>
            </div>
        </div>

        <!-- Empty State -->
        <div class="empty-state" *ngIf="filteredActivities.length === 0 && !isLoading && currentView !== 'month'">
            <mat-icon class="empty-icon">event_busy</mat-icon>
            <h3>Nu exista activitati</h3>
            <p>Nu au fost gasite activitati pentru criteriile selectate.</p>
            <button mat-raised-button color="primary" (click)="createNewActivity()" *ngIf="canCreateActivity()">
                <mat-icon>add</mat-icon>
                Creaza prima activitate
            </button>
        </div>
    </div>
</div>

<!-- Day Activities Side Panel -->
<div class="activity-details-panel day-activities-panel" [class.open]="showDayActivities"
    *ngIf="showDayActivities && selectedDateForSidebar">
    <div class="panel-header">
        <h3>Activități pentru {{ formatActivityDateShort(selectedDateForSidebar.toISOString().split('T')[0]) }}</h3>
        <button mat-icon-button (click)="closeActivityDetails()">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div class="panel-content">
        <div class="activities-count">
            <p>{{ selectedDateActivities.length }} activitate{{ selectedDateActivities.length === 1 ? '' : 'ăți' }}
                programată{{ selectedDateActivities.length === 1 ? '' : 'e' }}</p>
        </div>

        <div class="day-activities-list">
            <div class="day-activity-card" *ngFor="let activity of selectedDateActivities; trackBy: trackByActivity"
                (click)="onActivityClick(activity)">
                <div class="activity-card-header">
                    <div class="activity-status-badge" [style.background-color]="getStatusColor(activity.status)">
                        {{ getStatusLabel(activity.status) }}
                    </div>
                    <div class="activity-time-badge">
                        {{ getFormattedTimeRange(activity) }}
                    </div>
                </div>
                <div class="activity-card-content">
                    <h4>{{ activity.title }}</h4>
                    <p class="activity-description" *ngIf="activity.description">{{ activity.description }}</p>
                    <div class="activity-meta">
                        <div class="meta-item" *ngIf="activity.activity_type">
                            <mat-icon>category</mat-icon>
                            <span>{{ activity.activity_type.name }}</span>
                        </div>
                        <div class="meta-item" *ngIf="activity.location">
                            <mat-icon>place</mat-icon>
                            <span>{{ activity.location }}</span>
                        </div>
                        <div class="meta-item" *ngIf="activity.duration_minutes">
                            <mat-icon>timer</mat-icon>
                            <span>{{ activity.duration_minutes }} min</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Activity Details Side Panel -->
<div class="activity-details-panel" [class.open]="showActivityDetails" *ngIf="selectedActivityForDetails">
    <div class="panel-header">
        <h3>Detalii Activitate</h3>
        <button mat-icon-button (click)="closeActivityDetails()">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div class="panel-content">
        <div class="activity-main-info">
            <div class="activity-status-badge"
                [style.background-color]="getStatusColor(selectedActivityForDetails.status)">
                {{ getStatusLabel(selectedActivityForDetails.status) }}
            </div>
            <h4>{{ selectedActivityForDetails.title }}</h4>
            <p class="activity-description" *ngIf="selectedActivityForDetails.description">
                {{ selectedActivityForDetails.description }}
            </p>
        </div>

        <div class="activity-schedule-info">
            <div class="info-row">
                <mat-icon>calendar_today</mat-icon>
                <span>{{ formatActivityDateShort(selectedActivityForDetails.scheduled_date) }}</span>
            </div>
            <div class="info-row">
                <mat-icon>access_time</mat-icon>
                <span>{{ getFormattedTimeRange(selectedActivityForDetails) }}</span>
            </div>
            <div class="info-row" *ngIf="selectedActivityForDetails.duration_minutes">
                <mat-icon>timer</mat-icon>
                <span>{{ selectedActivityForDetails.duration_minutes }} minute</span>
            </div>
            <div class="info-row" *ngIf="selectedActivityForDetails.location">
                <mat-icon>place</mat-icon>
                <span>{{ selectedActivityForDetails.location }}</span>
            </div>
            <div class="info-row" *ngIf="selectedActivityForDetails.activity_type">
                <mat-icon>category</mat-icon>
                <span>{{ selectedActivityForDetails.activity_type.name }}</span>
            </div>
        </div>

        <div class="activity-notes" *ngIf="selectedActivityForDetails.notes">
            <h5>Notițe</h5>
            <p>{{ selectedActivityForDetails.notes }}</p>
        </div>

        <div class="activity-actions">
            <button mat-stroked-button color="primary" (click)="startEditingActivity()">
                <mat-icon>edit</mat-icon>
                Editează
            </button>
            <button mat-stroked-button color="accent" (click)="rescheduleActivity(selectedActivityForDetails)">
                <mat-icon>schedule</mat-icon>
                Reprogramează
            </button>
            <button mat-button [matMenuTriggerFor]="activityExportMenu">
                <mat-icon>download</mat-icon>
                Export
            </button>
            <mat-menu #activityExportMenu="matMenu">
                <button mat-menu-item (click)="exportSingleActivity(selectedActivityForDetails, 'pdf')">
                    <mat-icon>picture_as_pdf</mat-icon>
                    <span>Export PDF</span>
                </button>
                <button mat-menu-item (click)="exportSingleActivity(selectedActivityForDetails, 'csv')">
                    <mat-icon>table_chart</mat-icon>
                    <span>Export CSV</span>
                </button>
            </mat-menu>
        </div>

        <!-- Cancel Activity Section -->
        <div class="cancel-activity-section">
            <h5>Anulare Activitate</h5>
            <p>Dacă activitatea nu mai poate fi realizată, o poți anula permanent.</p>
            <button mat-stroked-button color="warn" (click)="cancelActivity(selectedActivityForDetails)">
                <mat-icon>cancel</mat-icon>
                Anulează Activitatea
            </button>
        </div>

        <!-- Quick Edit Form -->
        <div class="quick-edit-form" *ngIf="isEditingActivity">
            <h5>Editare Rapidă</h5>
            <mat-form-field appearance="outline" class="full-width">
                <mat-label>Status</mat-label>
                <mat-select [(ngModel)]="selectedActivityForDetails.status">
                    <mat-option *ngFor="let status of statusOptions" [value]="status.key">
                        {{ status.label }}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" class="full-width">
                <mat-label>Notițe</mat-label>
                <textarea matInput [(ngModel)]="selectedActivityForDetails.notes" rows="3"
                    placeholder="Adaugă notițe despre activitate...">
        </textarea>
            </mat-form-field>

            <div class="edit-actions">
                <button mat-button (click)="isEditingActivity = false">
                    Anulează
                </button>
                <button mat-raised-button color="primary" (click)="saveActivityChanges(selectedActivityForDetails)">
                    Salvează
                </button>
            </div>
        </div>
    </div>
</div>

<!-- Panel Backdrop -->
<div class="panel-backdrop" *ngIf="showActivityDetails || showDayActivities" (click)="closeActivityDetails()">
</div>

<!-- Floating Action Button for Mobile -->
<button mat-fab color="primary" class="fab-mobile" (click)="createNewActivity()"
    *ngIf="canCreateActivity() && isMobile">
    <mat-icon>add</mat-icon>
</button>